import React from 'react';
import { locales } from '../../../translations/locales';
import { _$ } from '../../../controllers/dom';

const Remove = (props) => {
    const { locale, ModuleRP, vehicle } = props;

    const removeVehicle = () => {
        ModuleRP.removeVehicleMission(vehicle.id, _$('removeReason').value);
    };

    return (
        <div>
            <p className='text-center'>{vehicle.name}</p>
            <p className='text-danger'>{locales[locale].sgo.confirmRemoveVehicle}</p>
            <textarea
                id='removeReason'
                className='form-control'
                rows='1'
                placeholder={locales[locale].sgo.removeReason}
            />
            <div className='text-center'>
                <button
                    type='button'
                    className='btn btn-danger m-1'
                    data-dismiss='modal'
                    onClick={removeVehicle}
                >
                    {locales[locale].sgo.removeVehicle}
                </button>
            </div>
        </div>
    );
};

export default Remove;
